import { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { InnerSearch } from "../components/search/InnerSearch";
import { RealtedVideo } from "../components/realtedVideo/RealtedVideo";
import { HelpfulFeedback } from "../components/HelpfulFeedback/HelpfulFeedback";

export const VideosDetails = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const { state } = useLocation();
  const navigate = useNavigate();
  const fetchIDsUsed = state?.detailsIDs;
  const [contentSteps, setContentSteps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getEmbedUrl = (url = "") => {
    if (!url) return "";

    try {
      if (url.includes("youtube.com/watch")) {
        const videoId = new URL(url).searchParams.get("v");
        return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
      }

      if (url.includes("youtu.be")) {
        const videoId = url.split("/").pop();
        return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
      }

      return url;
    } catch {
      return "";
    }
  };

  const fetchContentSteps = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const payload = {
        ContentCode: fetchIDsUsed?.contentCode || "",
        ContentTypeID: fetchIDsUsed?.contentTypeID || 2,
        CategoryID: fetchIDsUsed?.categoryID || 0,
        IsActive: 1,
        PageNumber: 1,
        PageSize: 10,
        SearchValue: fetchIDsUsed?.contentCode || "",
        IsSearch: fetchIDsUsed?.IsSearch || 0,
      };
      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchContentSteps`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      const result = response?.data?.result;
      if (!result || (Array.isArray(result) && result.length === 0)) {
        navigate("/VZYSupport/NoResultsFound");
        return;
      }
      setContentSteps(response?.data?.result?.contentSteps ?? []);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error(err);
      setError("Failed to load video details");
    } finally {
      setLoading(false);
    }
  }, [apiBaseURL, fetchIDsUsed?.contentCode]);

  useEffect(() => {
    fetchContentSteps();
  }, [fetchContentSteps]);

  const contentItem = contentSteps[0];

  const innerSearch = {
    pageName: "Video Tutorials",
    breadcrumb: [
      {
        label: "Home",
        url: "/VZYSupport/helpSupport",
      },
      // { label: "All Videos" },
      { label: contentItem?.contentTitle || "Video Details" },
    ],
  };

  return (
    <>
      <InnerSearch innerSearch={innerSearch} />

      <section className="inner-page-details">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              {loading && <p>Loading video...</p>}
              {error && <p className="error-text">{error}</p>}

              {!loading && !error && contentItem && (
                <>
                  <h4 className="detail-page-title">
                    {contentItem.contentTitle}
                  </h4>
                  <div className="faq-desciption-row">
                    {contentItem.imageAndVideoUrl && (
                      <iframe
                        src={getEmbedUrl(contentItem.imageAndVideoUrl)}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title={contentItem.contentTitle}
                      />
                    )}
                  </div>
                  <HelpfulFeedback
                    title="Was this video helpful?"
                    fetchIDsUsed={contentItem}
                  />
                </>
              )}
            </div>
            <div className="col-md-3">
              <h4 className="detail-page-sidebar-title">Related Videos</h4>
              <div>
                {/* <RealtedVideo contentItem={contentItem} /> */}
                <RealtedVideo contentItem={2} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
